module.exports = {"locale":"en-US","messages":{"login.notfoundmessage":"<p> You have successfully logged in using your {socialLoginDesc} account with the email address of {props.email}. </p> <p> There's just one more step to access your account.  Don't worry, you'll only have to do this once, and we'll remember who you are for your next visit.</p>","app.address":"Address {num} {optional}"}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en-US.json
// module id = 1549
// module chunks = 1